import { Directive, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDocumentMask][ngModel]',
})
export class DocumentMaskDirective implements OnChanges {
  @Input() ngModel: string | null;

  private lastValue: string | null = null;

  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleanValue = input.value.replace(/[^0-9]/g, '');

    let formattedValue = '';
    if (cleanValue.length <= 11) {
      formattedValue = this.formatPartialCPF(cleanValue);
    } else if (cleanValue.length <= 14) {
      formattedValue = this.formatPartialCNPJ(cleanValue);
    }

    // Evita atualizações cíclicas
    if (formattedValue !== this.lastValue) {
      this.lastValue = formattedValue;
      this.control.control?.setValue(formattedValue, { emitModelToViewChange: false });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ngModel'] && this.control.control) {
      const currentValue = changes['ngModel'].currentValue;
      const formattedValue = this.formatValue(currentValue);

      // Evita atualizações cíclicas
      if (formattedValue !== this.lastValue) {
        this.lastValue = formattedValue;
        this.control.control.setValue(formattedValue, { emitModelToViewChange: false });
      }
    }
  }

  private formatValue(value: string | null): string {
    if (value === null || value === undefined) {
      return '';
    }

    const cleanValue = value.toString().replace(/[^0-9]/g, '');

    if (cleanValue.length <= 11) {
      return this.formatPartialCPF(cleanValue);
    } else if (cleanValue.length <= 14) {
      return this.formatPartialCNPJ(cleanValue);
    }
    return cleanValue.substring(0, 14); // Limita ao máximo de CNPJ
  }

  private formatPartialCPF(cpf: string): string {
    return cpf
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
      .replace(/(-\d{2})\d+?$/, '$1');
  }

  private formatPartialCNPJ(cnpj: string): string {
    return cnpj
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5')
      .replace(/(-\d{2})\d+?$/, '$1');
  }
}
